<section
  class="status-modal"
  [class.status-modal--error]="data.state === 'error'"
  [class.status-modal--success]="data.state === 'success'"
  [class.status-modal--info]="data.state === 'info'"
  [class.status-modal--warning]="data.state === 'warning'"
  role="dialog"
  aria-modal="true"
>
  <button type="button" class="status-modal__close" aria-label="Close modal" (click)="close()">
    <fa-icon [icon]="['fas', 'xmark']" />
  </button>

  <div class="status-modal__content">
    <div class="status-modal__title">
      <fa-icon class="status-modal__title-icon" [icon]="config().icon" />

      <span class="status-modal__title-text">
        {{ title() }}
      </span>
    </div>

    <p class="status-modal__message">
      <app-highlighted-message [text]="data.message" [highlights]="data.highlights ?? []" />
    </p>

    <button matButton="elevated" (click)="close()">Close</button>
  </div>
</section>
